import { connectRouter } from 'connected-react-router/immutable';
import { combineReducers } from 'redux-immutable';

import auth from '../Services/Auth/reducer';
import contracts from '../Services/Contracts/reducer';
import dashboard from '../Services/Dashboard/reducer';
import parties from '../Services/Parties/reducer';
import plugins from '../Services/Plugins/reducer';
import products from '../Services/Products/reducer';
import quotations from '../Services/Quotations/reducer';
import salesroutes from '../Services/SalesRoutes/reducer';
import settings from '../Services/Settings/reducer';
import surveys from '../Services/Surveys/reducer';
import stats from '../Services/Stats/reducer';
import system from '../Services/System/reducer';
import theme from '../Services/Theme/reducer';

import { dynamicReducers } from '../Services/customer/reducer-wrapper';

const rootReducer = history =>
  combineReducers({
    router: connectRouter(history),
    auth,
    contracts,
    dashboard,
    parties,
    products,
    quotations,
    settings,
    surveys,
    stats,
    system,
    plugins,
    theme,
    salesroutes,
    ...dynamicReducers,
  });

export default rootReducer;
